

export enum PlatformTrialMode {
  FREE_TRIAL_WITH_CARD = "FREE_TRIAL_WITH_CARD",
  FREE_TRIAL_WITHOUT_CARD = "FREE_TRIAL_WITHOUT_CARD" // user has this plan for a certain number of days, then needs to upgrade
}

export let FREE_TRIAL_PLATFORM_MODE = PlatformTrialMode.FREE_TRIAL_WITH_CARD;

export const NUMBER_OF_FREE_TRIAL_DAYS = 30;

export function isTrialWithCardActive() {
  return FREE_TRIAL_PLATFORM_MODE == PlatformTrialMode.FREE_TRIAL_WITH_CARD;
}

export function isTrialWithoutCardActive() {
  return FREE_TRIAL_PLATFORM_MODE == PlatformTrialMode.FREE_TRIAL_WITHOUT_CARD;
}

export const EMPTY_IMG =
  "https://d8avu785lzlph.cloudfront.net/images/empty-image.png";

export const CARD_EMPTY_IMG =
  "../../assets/images/common/empty-card-img.jpg";
// export const CARD_EMPTY_IMG =
//   "https://d8avu785lzlph.cloudfront.net/images/neo-img/empty-file-upload.png";

export const EMPTY_IMG_SQUARE =
  "../../assets/images/common/empty-file-upload.png";

export const DEFAULT_FONT_NAME = "Inter";

export const ONLINECOURSEHOST_PRIMARY_COLOR = "#11294f";

export const ONLINECOURSEHOST_ACCENT_COLOR = "#EB3B3B";

export const DEFAULT_SCHOOL_PRIMARY_COLOR = "#11294f";

export const DEFAULT_SCHOOL_ACCENT_COLOR = "#EB3B3B";
